import { app } from '@packages/app';
import {
    NotificationServiceProvider,
    NotificationServiceProviderImpl,
} from '@packages/notifications/lib/NotificationServiceProvider';
import { OptionsObject, VariantType } from 'notistack';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: useNotify
 * @date:  15.10.2019
 * @time:  19:08
 */
export function useNotify() {
    const notify: NotificationServiceProviderImpl = app(NotificationServiceProvider);
    /**
     * Open notification
     * @param message
     * @param variant
     * @param options
     * @returns {string|null}
     */
    const openNotification = (message: any, variant: VariantType = 'info', options?: OptionsObject) =>
        notify.push(variant, message, options);

    /**
     * Create Success notification
     * @param message
     * @param options
     * @returns {string|null}
     */
    const notifySuccess = (message: any, options?: OptionsObject) => notify.success(message, options);

    /**
     * Create Warning notification
     * @param message
     * @param options
     * @returns {string|null}
     */
    const notifyWarning = (message: any, options?: OptionsObject) => notify.warning(message, options);

    /**
     * Create Error notification
     * @param message
     * @param options
     * @returns {string|null}
     */
    const notifyError = (message: any, options?: OptionsObject) => notify.error(message, options);

    /**
     * Create Info notification
     * @param message
     * @param options
     * @returns {string|null}
     */
    const notifyInfo = (message: any, options?: OptionsObject) => notify.info(message, options);

    return {
        success: notifySuccess,
        warning: notifyWarning,
        error: notifyError,
        info: notifyInfo,
        openNotification,
        notifySuccess,
        notifyWarning,
        notifyError,
        notifyInfo,
    };
}

export default useNotify;
